// import our components

import headerNav from './components/headerNav'
import sliders from './components/sliders'
import main from './components/main'
import management from './components/management'
import contact from './components/contact'
import showCards from './components/showCards'
import hero from './components/hero'

// import required libraries

import $ from 'jquery'



// call funcitons

headerNav($);
main($);
sliders($);
contact($);
showCards($);
management($);
hero($);




